import { render, staticRenderFns } from "./ContextMenuMobile.vue?vue&type=template&id=6045ac45"
import script from "./ContextMenuMobile.vue?vue&type=script&lang=js"
export * from "./ContextMenuMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports